import React from 'react'

import useAppSelector from '../../../../store/hooks/useAppSelector'
import { appErrorModalConfigSelector } from '../../store/appSelectors'
import { ErrorModalType } from '../../types'
import BoxPickupUnavailableProductList from '../../../checkout/components/BoxPickupUnavailableProductList'
import CheckoutItemsOverrideMenuConflictList from '../../../checkout/components/CheckoutItemsOverrideMenuConflictList'

export default function ErrorModalAdditionalInfo() {
  const errorModalConfig = useAppSelector(appErrorModalConfigSelector)

  switch (errorModalConfig?.errorModalType) {
    case ErrorModalType.CheckoutBoxPickupUnAvailableProducts:
      return <BoxPickupUnavailableProductList />

    case ErrorModalType.CheckoutUnavailableProductsDueToOverrideMenu:
      return <CheckoutItemsOverrideMenuConflictList />

    default:
      return null
  }
}
